interface AppLogoProps {
  size?: number;
  collapsed?: boolean;
}

/**
 * Visual mark for AIDU — gradient diamond with the wordmark.
 * Used in the sidebar and on the auth split screen.
 */
export function AppLogo({ size = 32, collapsed }: AppLogoProps) {
  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 10,
        userSelect: 'none',
      }}
    >
      <span
        style={{
          width: size,
          height: size,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: 8,
          background: 'linear-gradient(135deg, #2563eb 0%, #8b5cf6 100%)',
          color: '#ffffff',
          fontWeight: 700,
          fontSize: size * 0.42,
          letterSpacing: 1,
          boxShadow: '0 6px 20px rgba(37, 99, 235, 0.35)',
        }}
        aria-hidden
      >
        A
      </span>
      {!collapsed ? (
        <span
          style={{
            fontWeight: 700,
            fontSize: size * 0.55,
            letterSpacing: 1,
            background: 'linear-gradient(90deg, #2563eb 0%, #8b5cf6 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
        >
          AIDU
        </span>
      ) : null}
    </div>
  );
}
